import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {PathwayConstants} from "./pathway.constants";
import {CreDetailsService} from "@tva/ng-migration/cre-tracking/services/cre-details.service";
import {MatExpansionPanel} from "@angular/material/expansion";
import {Pathway, PathwayDetails, PathwayEntry, PathwaySchoolCourse} from "@tva/ng-migration/cre-tracking/models";
import {first} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {PathwayRequirementsModalComponent} from "@tva/ng-migration/cre-tracking/components/search/cre-management-search-results/pathway-requirements-modal/pathway-requirements-modal.component";
import {CourseNameValidator} from "./pathway.validators";
import {NotificationService, TvActionChipsComponent} from "@tva/ng-migration/uicomponents";
import {UnsavedChangesService} from "@tva/ng-migration/shared/services/unsavedChanges.service";


import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-cre-pathway',
    templateUrl: './pathway.component.html',
    styleUrls: ['./pathway.component.scss']
})
export class PathwayComponent implements AfterViewInit, OnDestroy {
    pathwaysCoursesColumns: string[] = ["name", "notes", "actions"];
    pathwaysCoursesDataSource: MatTableDataSource<any>;

    pathwayCoursesDataForm: FormArray = new FormArray([]);
    pathwayCoursesData: PathwayEntry[] = [];
    isLoaded: boolean;
    originalData: PathwayDetails;
    formSettings: FormGroup;
    wasValidated = false;
    lastRequirementGroupSequence = 0;

    @ViewChild('table') table: MatTable<any>;
    @ViewChild(MatExpansionPanel) expansionPanel: MatExpansionPanel;
    @ViewChildren(TvActionChipsComponent) courseLists: QueryList<TvActionChipsComponent>;

    @Input() pathway: Pathway;
    @Input() schoolCourses: PathwaySchoolCourse[];
    @Output() wasModified: EventEmitter<boolean> = new EventEmitter();
    @Output() wasSelected: EventEmitter<any> = new EventEmitter();

    errors: any;
    settingsError: any;
    duplicateCourseError: any;

    constructor(private creDetails: CreDetailsService,
        private notificationService: NotificationService,
        private dialog: MatDialog,
        private unsavedChanges: UnsavedChangesService) {
        this.setSettingsForm();
    }

    get errorMessages(): any{
        return PathwayConstants.errors;
    }

    ngAfterViewInit(): void {
        this.pathwaysCoursesDataSource = new MatTableDataSource(this.pathwayCoursesData);
    }

    ngOnDestroy() {
      this.notificationService.clearMessages();
    }

  pathwaysEditCourse(pathwayEntry: PathwayEntry) {
        let pathwayCourses = [];
        if (pathwayEntry.pathwayCourses.length > 1){
            pathwayCourses = pathwayEntry.pathwayCourses;
        } else {
            if (pathwayEntry.form.value.courseId.length){
                let course;
                if (pathwayEntry.form.value.courseId[0] === PathwayConstants.non_k12_course ) {
                    course = {name: pathwayEntry.form.value.name};
                } else {
                    course = {courseId: pathwayEntry.form.value.courseId[0].courseId, name: pathwayEntry.form.value.courseId[0].courseName}
                }
                pathwayCourses = [course];
            }
        }

        const data = {
            pathwayCourses,
            schoolCourses : this.schoolCourses
        }
        this.dialog.open(PathwayRequirementsModalComponent, {width: '800px', data}).afterClosed().subscribe(modifiedCourses => {
            if (modifiedCourses){
                const courses = [];
                const {requirementId} = pathwayEntry;
                let requirementGroup;
                if (modifiedCourses.length === 1){
                    if (!pathwayEntry.form){
                        const form = this.createForm();
                        pathwayEntry.form = form;
                        this.pathwayCoursesDataForm.push(form);
                    }
                    let courseId, name;

                    pathwayEntry.form.get('courseId').setValue(modifiedCourses[0].course);

                    if (modifiedCourses[0].course[0] === PathwayConstants.non_k12_course){
                        pathwayEntry.form.get('name').setValue(modifiedCourses[0].name);
                        name = modifiedCourses[0].name;
                    } else {
                        courseId = modifiedCourses[0].course.courseId;
                        name = modifiedCourses[0].course.courseName;
                    }
                    courses.push({ requirementId, courseId, name });
                } else {
                    if (!requirementId){
                        requirementGroup = this.getRequirementGroupSequence();
                    }
                    if (pathwayEntry.form){
                        this.pathwayCoursesDataForm.removeAt(this.pathwayCoursesDataForm.controls.indexOf(pathwayEntry.form));
                        pathwayEntry.form = null;
                    }
                    modifiedCourses.forEach(entry => {
                        let courseId, name = entry.name;
                        let course;

                        if (entry.course[0] !== PathwayConstants.non_k12_course){
                            name = entry.course[0].courseName;
                            courseId = entry.course[0].courseId;
                        }

                        if (requirementId){
                            course = { requirementId, courseId, name };
                        } else {
                            course = { requirementGroup, courseId, name };
                        }

                        courses.push(course);
                    });
                }
                pathwayEntry.pathwayCourses = courses;
                this.notifyModification();
            }
        })
    }

    drop(event: CdkDragDrop<string[]>) {
        const previousIndex = this.pathwaysCoursesDataSource.data.findIndex(row => row === event.item.data);
        moveItemInArray(this.pathwaysCoursesDataSource.data,previousIndex, event.currentIndex);
        this.pathwaysCoursesDataSource.data = this.pathwaysCoursesDataSource.data.slice();
        this.notifyModification();
        console.log("item dragged", this.pathwaysCoursesDataSource.data)
      }



    pathwaysDeleteCourse(pathwayEntry: PathwayEntry) {
        const i = this.pathwayCoursesData.indexOf(pathwayEntry);
        this.pathwayCoursesData.splice(i, 1);
        this.pathwayCoursesDataForm.removeAt(this.pathwayCoursesDataForm.controls.indexOf(pathwayEntry.form));
        this.updateDataTable();
        this.notifyModification();
    }

    addNewCourse(): void {
        const form = this.createForm();
        this.loadControlTriggerChange(form);
        this.pathwayCoursesDataForm.push(form);
        this.pathwayCoursesData.push(
            {
                requirementId: null,
                pathwayCourses: [],
                form
            }
        )
        this.updateDataTable();
        this.notifyModification();
    }

    reset() {
        this.setSettingsForm();
        this.updateData(this.originalData);
        this.resetModifications();
        this.clearNotifications();
        this.wasValidated = false;
        this.resetRequiorementGroupSequence();
    }

    restart(){
        this.setSettingsForm();
        this.resetModifications();
        this.wasValidated = false;
        this.resetRequiorementGroupSequence();
    }

    save(schoolId){
        if(this.validate()){
            let courses = [];
            this.pathwayCoursesData.forEach(entry => {
                let coursesTobeAdded = [];
                const sequenceId = this.pathwaysCoursesDataSource.data.indexOf(entry) + 1;

                //no new row: existing db data
                if(entry.pathwayCourses.length > 0){
                    const {requirementId} = entry;

                    if (entry.pathwayCourses.length === 1) {
                        let newCourse;

                        if (entry.form.value.courseId[0] === PathwayConstants.non_k12_course){
                            newCourse = { requirementId, name: entry.form.value.name, sequenceId};
                        } else {
                            newCourse = { requirementId, courseId: entry.form.value.courseId[0].courseId, sequenceId }
                        }

                        coursesTobeAdded.push(newCourse);
                    } else {
                        entry.pathwayCourses.forEach(course => {
                            let newCourse;

                            if (course.courseId) {
                                newCourse = {
                                    courseId: course.courseId,
                                    sequenceId
                                }
                            } else {
                                newCourse = {
                                    name: course.name,
                                    sequenceId
                                };
                            }

                            if (requirementId){
                                newCourse = { ...newCourse, requirementId, sequenceId};
                            } else {
                                newCourse = { ...newCourse, requirementGroup: course.requirementGroup, sequenceId};
                            }

                            coursesTobeAdded.push(newCourse);
                        });
                    }

                } else {
                    //new row added: get from form
                    let course = entry.form.value;
                    if (course.courseId.length && course.courseId[0] === PathwayConstants.non_k12_course){
                        coursesTobeAdded.push({
                            name: course.name,
                            sequenceId
                        });
                    } else {
                        coursesTobeAdded.push({
                            courseId: course.courseId[0].courseId,
                            sequenceId
                        });
                    }

                }

                courses = [...courses, ...coursesTobeAdded];
            })

            const data = {
                "xschcteId" : this.pathway.xschcteid,
                schoolId,
                courses,
                "participatorCourseCount" : this.formSettings.value.participatorCourseCount === "" ? null : isNaN(this.formSettings.value.participatorCourseCount) ? this.formSettings.value.participatorCourseCount.toString() : this.formSettings.value.participatorCourseCount,
                "concentratorCourseCount" : this.formSettings.value.concentratorCourseCount === "" ? null : isNaN(this.formSettings.value.concentratorCourseCount) ? this.formSettings.value.concentratorCourseCount.toString() : this.formSettings.value.concentratorCourseCount,
                "completerCourseCount" : this.formSettings.value.completerCourseCount === "" ? null : isNaN(this.formSettings.value.completerCourseCount) ? this.formSettings.value.completerCourseCount.toString() : this.formSettings.value.completerCourseCount,
            }
            this.clearNotifications();
            //invoke BE svc to save pathway changes
            this.creDetails.saveCtePathways(data).subscribe(
                results => {
                    this.notificationService.showSuccessMessage();
                    this.unsavedChanges.saveChanges();
                    this.restart();
                    this.loadPathways(false);

                },
                error => {
                    this.errors = error.error._errors[0];
                    this.notificationService.showErrorMessage();

                    let invalidParticipatorSetting = this.errors.includes("Participator setting. Please enter a non-zero and positive value.");
                    let coursesExist = this.pathwayCoursesDataForm.value.length > 0;

                    //participator setting errors
                    if(this.errors.includes("Participator setting shall be left empty")){
                        this.settingsError = PathwayConstants.errors.settings.participatorCount
                    }
                    if(this.errors.includes("less than the Concentrator") || invalidParticipatorSetting && coursesExist){
                        this.settingsError = PathwayConstants.errors.settings.participatorInvalid
                    }
                    if(this.errors.includes("less than the Completer") || invalidParticipatorSetting && coursesExist){
                        this.settingsError = PathwayConstants.errors.settings.participatorCompletorInvalid
                    }

                    //concentrator setting errors
                    if(this.errors.includes("Concentrator setting shall be left empty")){
                        this.settingsError = PathwayConstants.errors.settings.concentratorCount
                    }
                    if(this.errors.includes("Invalid value for the Concentrator setting")){
                        this.settingsError = PathwayConstants.errors.settings.concentratorInvalid
                    }

                    //completor setting errors
                    if(this.errors.includes("Completer setting shall be left empty")){
                        this.settingsError = PathwayConstants.errors.settings.completorCount
                    }
                    if(this.errors.includes("Completer setting is required")){
                        this.settingsError = PathwayConstants.errors.settings.completorRequired
                    }
                    if(this.errors.includes("Invalid value for the Completer setting.") && coursesExist){
                        this.settingsError = PathwayConstants.errors.settings.completorInvalid
                    }

                    if(this.errors.includes("java.lang.NumberFormatException")){
                        this.settingsError = PathwayConstants.errors.settings.invalidSettings
                    }

                    //duplicate error
                    if(this.errors.includes("A course can not be duplicated in the pathway.")){
                        this.duplicateCourseError = PathwayConstants.errors.name.duplicateCourse
                    }
                }
            )

        } else {
            this.notificationService.showErrorMessage();
        }
    }

    hasNonK12CourseNameField(pathwayEntry: PathwayEntry): boolean {
        const courseId = pathwayEntry.form.get('courseId').value;
        return courseId.length && courseId[0] == PathwayConstants.non_k12_course;
    }

    getPathwayEntryNote(length: number): string {
        if (length > 1) {
            return PathwayConstants.notes_several_courses;
        }
        return '';
    }

    open() {
        this.resetModifications();
        this.loadPathways();
        this.isLoaded = true;
        this.expansionPanel.open();
    }

    close() {
        this.resetModifications();
        this.setSettingsForm();
        this.expansionPanel.close();
    }

    clearNotifications(){
        this.notificationService.clearMessages();
        this.settingsError = null;
        this.duplicateCourseError = null;
    }

    selectPathway() {
        this.wasSelected.emit(this.pathway);
    }

    pathwayFormErrorIsShown(pathwayEntry: PathwayEntry): boolean{
        return this.wasValidated && pathwayEntry.form.touched;
    }

    private loadPathways(clearNotification = true): void {
        if (clearNotification)
            this.clearNotifications();
        this.creDetails.getCtePathwayCourses(this.pathway.xschcteid).subscribe((pathwayDetails) => {
            this.originalData = pathwayDetails;
            this.updateData(pathwayDetails);
        })
    }

    private updateData(pathwayDetails: PathwayDetails): void {
        const formData = new FormArray([]);
        const entries = [];
        pathwayDetails.activeCourse.forEach((pathwayCourse) => {
            const found = entries.find(item => item.requirementId === pathwayCourse.requirementId && item.requirementId);
            if (found) {
                found.pathwayCourses.push(pathwayCourse);
            } else {
                entries.push(
                    {
                        requirementId: pathwayCourse.requirementId,
                        pathwayCourses: [pathwayCourse],
                        form: undefined
                    }
                )
            }
        });

        entries.forEach((entry) => {
            if (entry.pathwayCourses.length === 1) {
                const form = this.createForm();
                entry.form =  form;
                const courses: PathwaySchoolCourse[] = [];
                const pathwayCourse = entry.pathwayCourses[0];
                if (pathwayCourse.courseId) {
                    courses.push({courseId: pathwayCourse.courseId, courseName: pathwayCourse.name});
                } else {
                    courses.push(PathwayConstants.non_k12_course);
                    entry.form.get('name').setValue(pathwayCourse.name);
                }
                entry.form.get('courseId').setValue(courses);
                formData.push(form);
            }
        });

        this.pathwayCoursesDataForm = formData;
        this.pathwayCoursesData = entries;
        if (pathwayDetails.settings){
            this.formSettings.patchValue(pathwayDetails.settings);
        }
        this.setFormChanges();
        this.updateDataTable();
    }

    private updateDataTable(): void {
        this.pathwaysCoursesDataSource.data = [...this.pathwayCoursesData];
    }

    private notifyModification(): void {
        this.wasModified.emit(true);
    }

    private resetModifications(): void {
        this.wasModified.emit(false);
    }

    private setFormChanges(): void {
        this.loadControlTriggerChange(this.formSettings);
        this.pathwayCoursesDataForm.controls.forEach(form => this.loadControlTriggerChange(form));
    }

    private validate(): boolean{
        this.courseLists.forEach(courseList => courseList.validate());
        this.pathwayCoursesDataForm.controls.forEach(form => form.markAsTouched());
        this.wasValidated = true;
        return this.formSettings.valid && this.pathwayCoursesDataForm.valid;
    }

    private loadControlTriggerChange(control: AbstractControl) {
        control.valueChanges.pipe(first()).subscribe(() => {
            this.notifyModification();
        })
    }

    private setSettingsForm(){
        this.formSettings = new FormGroup(
            {
                participatorCourseCount: new FormControl(),
                concentratorCourseCount: new FormControl(),
                completerCourseCount: new FormControl(),
            }
        );
    }

    private createForm(): FormGroup{
        return new FormGroup(
            {
                courseId: new FormControl([], Validators.required),
                name: new FormControl(''),
            },[CourseNameValidator]
        );
    }

    private getRequirementGroupSequence(): number {
        return ++this.lastRequirementGroupSequence;
    }

    private resetRequiorementGroupSequence(): void {
        this.lastRequirementGroupSequence = 0;
    }
}
